import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import H5 from '@base/H5/H5';
import { CMSPriceHikeGoals } from '@utils/abconstants';
import { Spacings } from '../../../styleConstants';

const PriceHikeContainer = styled.div`
  background-color: #fdeeee;
  height: 56px;
  border-radius: ${({ borderRadius }) => borderRadius};
  padding: ${Spacings.SPACING_3B};
  ${({ theme }) => `${theme.breakpoints.down('tablet')} {
       text-align: left;
    };`}
`;

const PriceHikeContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PriceHikeIcon = styled.img`
  user-drag: none;
  user-select: none;
  width: 32px;
  height: 32px;
`;

const PriceHikeText = styled(H5)`
  color: #eb5757;
  margin-left: ${Spacings.SPACING_3B};
  ${({ theme }) => `${theme.breakpoints.down('mobile')} {
       font-size: 12px;
    };`}
`;

const PriceHike = ({ iconURL, message, borderRadius }) => {
  const experimentVariation = useSelector(
    ({ others }) => others.experimentVariations.price_hike_nudge_web
  );
  const router = useRouter();
  const { goalUID } = router.query;

  let priceHikeText = message;
  if (!CMSPriceHikeGoals.includes(goalUID)) {
    if (experimentVariation === 'Test1') {
      priceHikeText = 'Subscription prices will be increased soon';
    } else if (experimentVariation === 'Test2') {
      priceHikeText =
        'Subscription prices may go up by 15% next month. Buy now!';
    }
  }

  return (
    <PriceHikeContainer borderRadius={borderRadius}>
      <PriceHikeContent>
        <PriceHikeIcon src={iconURL} alt="-" />
        <PriceHikeText>{priceHikeText}</PriceHikeText>
      </PriceHikeContent>
    </PriceHikeContainer>
  );
};

PriceHike.propTypes = {
  iconURL: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  borderRadius: PropTypes.string
};

PriceHike.defaultProps = {
  borderRadius: Spacings.SPACING_2B
};

export default PriceHike;
